module.exports = __webpack_public_path__ + "static/media/808-cymbal-01.30eed6a3.wav";